import http from './http'
const base = '/Telas/ConfiguracaoProvedores'
export default {
  async getOptions () { return (await http.get(`${base}/GetOptions`)).data },
  async getAccounts () { return (await http.get(`${base}/GetAccounts`)).data },
  async getIdentifiers () { return (await http.get(`${base}/GetIdentifiers`)).data },
  async getCredentials () { return (await http.get(`${base}/GetCredentials`)).data },
  async getAudit () { return (await http.get(`${base}/GetAudit`)).data },
  async saveAccount (item) { return (await (item.id ? http.put(`${base}/SaveAccount/${item.id}`, item) : http.post(`${base}/SaveAccount`, item))).data },
  async saveIdentifier (item) { return (await (item.id ? http.put(`${base}/SaveIdentifier/${item.id}`, item) : http.post(`${base}/SaveIdentifier`, item))).data },
  async saveCredential (item) { return (await (item.id ? http.put(`${base}/SaveCredential/${item.id}`, item) : http.post(`${base}/SaveCredential`, item))).data },
  async testCredential (id) { return (await http.post(`${base}/TestCredential/${id}`)).data }
}
